import { Address } from "./address.model";

export class TPApplicationInfoModel {
    constructor(
        public FirstName: string = '',
        public LastName: string = '',
        public MiddleName: string = '',
        public Phone: string = '',
        public PhoneExtension: string = '',
        public Position: string = '',
        public Email: string = '',
        public AlternateEmailAddress: string = '',
        public Role: string = '',
        public MailingAddress: Address | null = new Address('', '', '', '', '', '', '', '') ) { }
}